export default __webpack_public_path__ + "static/media/hand-white.762ad3da.png";